import _createClass from "/home/engi/Projects/mine/bellmeet-panel/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _classCallCheck from "/home/engi/Projects/mine/bellmeet-panel/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _inherits from "/home/engi/Projects/mine/bellmeet-panel/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/engi/Projects/mine/bellmeet-panel/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
import _wrapNativeSuper from "/home/engi/Projects/mine/bellmeet-panel/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/wrapNativeSuper";
import _createForOfIteratorHelper from "/home/engi/Projects/mine/bellmeet-panel/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
var b = Object.defineProperty,
    p = Object.defineProperties;
var l = Object.getOwnPropertyDescriptors;
var a = Object.getOwnPropertySymbols;
var c = Object.prototype.hasOwnProperty,
    x = Object.prototype.propertyIsEnumerable;

var d = function d(n, t, i) {
  return t in n ? b(n, t, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: i
  }) : n[t] = i;
},
    N = function N(n, t) {
  for (var i in t || (t = {})) {
    c.call(t, i) && d(n, i, t[i]);
  }

  if (a) {
    var _iterator = _createForOfIteratorHelper(a(t)),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var i = _step.value;
        x.call(t, i) && d(n, i, t[i]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  return n;
},
    v = function v(n, t) {
  return p(n, l(t));
};

var u = function u(n, t) {
  return function () {
    return n && (t = n(n = 0)), t;
  };
};

var R = function R(n, t) {
  return function () {
    return t || n((t = {
      exports: {}
    }).exports, t), t.exports;
  };
};

var r,
    o = u(function () {
  r = /*#__PURE__*/function (_Error) {
    _inherits(r, _Error);

    var _super = _createSuper(r);

    function r() {
      _classCallCheck(this, r);

      return _super.apply(this, arguments);
    }

    return r;
  }( /*#__PURE__*/_wrapNativeSuper(Error));
});
var m,
    g = u(function () {
  m = /*#__PURE__*/function () {
    function m() {
      _classCallCheck(this, m);

      this.N = 624;
      this.M = 397;
      this.MATRIX_A = 2567483615;
      this.UPPER_MASK = 2147483648;
      this.LOWER_MASK = 2147483647;
      this.mt = new Array(this.N);
      this.mti = this.N + 1;
      this.mag01 = [0, this.MATRIX_A];
    }

    _createClass(m, [{
      key: "unsigned32",
      value: function unsigned32(t) {
        return t < 0 ? (t ^ this.UPPER_MASK) + this.UPPER_MASK : t;
      }
    }, {
      key: "subtraction32",
      value: function subtraction32(t, i) {
        return t < i ? this.unsigned32(4294967296 - (i - t) & 4294967295) : t - i;
      }
    }, {
      key: "addition32",
      value: function addition32(t, i) {
        return this.unsigned32(t + i & 4294967295);
      }
    }, {
      key: "multiplication32",
      value: function multiplication32(t, i) {
        var s = 0;

        for (var e = 0; e < 32; ++e) {
          t >>> e & 1 && (s = this.addition32(s, this.unsigned32(i << e)));
        }

        return s;
      }
    }, {
      key: "initGenrand",
      value: function initGenrand(t) {
        for (this.mt[0] = this.unsigned32(t & 4294967295), this.mti = 1; this.mti < this.N; this.mti++) {
          this.mt[this.mti] = this.addition32(this.multiplication32(1812433253, this.unsigned32(this.mt[this.mti - 1] ^ this.mt[this.mti - 1] >>> 30)), this.mti), this.mt[this.mti] = this.unsigned32(this.mt[this.mti] & 4294967295);
        }
      }
    }, {
      key: "initByArray",
      value: function initByArray(t, i) {
        this.initGenrand(19650218);
        var s = 1,
            e = 0,
            h = this.N > i ? this.N : i;

        for (; h; h--) {
          this.mt[s] = this.addition32(this.addition32(this.unsigned32(this.mt[s] ^ this.multiplication32(this.unsigned32(this.mt[s - 1] ^ this.mt[s - 1] >>> 30), 1664525)), t[e]), e), this.mt[s] = this.unsigned32(this.mt[s] & 4294967295), s++, e++, s >= this.N && (this.mt[0] = this.mt[this.N - 1], s = 1), e >= i && (e = 0);
        }

        for (h = this.N - 1; h; h--) {
          this.mt[s] = this.subtraction32(this.unsigned32(this.mt[s] ^ this.multiplication32(this.unsigned32(this.mt[s - 1] ^ this.mt[s - 1] >>> 30), 1566083941)), s), this.mt[s] = this.unsigned32(this.mt[s] & 4294967295), s++, s >= this.N && (this.mt[0] = this.mt[this.N - 1], s = 1);
        }

        this.mt[0] = 2147483648;
      }
    }, {
      key: "genrandInt32",
      value: function genrandInt32() {
        var t;

        if (this.mti >= this.N) {
          var i;

          for (this.mti === this.N + 1 && this.initGenrand(5489), i = 0; i < this.N - this.M; i++) {
            t = this.unsigned32(this.mt[i] & this.UPPER_MASK | this.mt[i + 1] & this.LOWER_MASK), this.mt[i] = this.unsigned32(this.mt[i + this.M] ^ t >>> 1 ^ this.mag01[t & 1]);
          }

          for (; i < this.N - 1; i++) {
            t = this.unsigned32(this.mt[i] & this.UPPER_MASK | this.mt[i + 1] & this.LOWER_MASK), this.mt[i] = this.unsigned32(this.mt[i + (this.M - this.N)] ^ t >>> 1 ^ this.mag01[t & 1]);
          }

          t = this.unsigned32(this.mt[this.N - 1] & this.UPPER_MASK | this.mt[0] & this.LOWER_MASK), this.mt[this.N - 1] = this.unsigned32(this.mt[this.M - 1] ^ t >>> 1 ^ this.mag01[t & 1]), this.mti = 0;
        }

        return t = this.mt[this.mti++], t = this.unsigned32(t ^ t >>> 11), t = this.unsigned32(t ^ t << 7 & 2636928640), t = this.unsigned32(t ^ t << 15 & 4022730752), t = this.unsigned32(t ^ t >>> 18), t;
      }
    }, {
      key: "genrandInt31",
      value: function genrandInt31() {
        return this.genrandInt32() >>> 1;
      }
    }, {
      key: "genrandReal1",
      value: function genrandReal1() {
        return this.genrandInt32() * (1 / 4294967295);
      }
    }, {
      key: "genrandReal2",
      value: function genrandReal2() {
        return this.genrandInt32() * (1 / 4294967296);
      }
    }, {
      key: "genrandReal3",
      value: function genrandReal3() {
        return (this.genrandInt32() + .5) * (1 / 4294967296);
      }
    }, {
      key: "genrandRes53",
      value: function genrandRes53() {
        var t = this.genrandInt32() >>> 5,
            i = this.genrandInt32() >>> 6;
        return (t * 67108864 + i) * (1 / 9007199254740992);
      }
    }]);

    return m;
  }();
});

var _f,
    y = u(function () {
  o();
  g();

  _f = /*#__PURE__*/function () {
    function f() {
      _classCallCheck(this, f);

      this.gen = new m();
      this.gen.initGenrand(new Date().getTime() % 1e9);

      var _iterator2 = _createForOfIteratorHelper(Object.getOwnPropertyNames(_f.prototype)),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var t = _step2.value;
          t === "constructor" || typeof this[t] != "function" || (this[t] = this[t].bind(this));
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    }

    _createClass(f, [{
      key: "rand",
      value: function rand() {
        var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 32768;
        var i = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

        if (i > t) {
          var s = i;
          i = t, t = s;
        }

        return Math.floor(this.gen.genrandReal2() * (t - i) + i);
      }
    }, {
      key: "seed",
      value: function seed(t) {
        if (typeof t != "number") throw new r("seed(S) must take numeric argument; is ".concat(typeof t));
        this.gen.initGenrand(t);
      }
    }, {
      key: "seed_array",
      value: function seed_array(t) {
        if (typeof t != "object") throw new r("seed_array(A) must take array of numbers; is ".concat(typeof t));
        this.gen.initByArray(t, t.length);
      }
    }]);

    return f;
  }();
});

export { N as a, v as b, u as c, R as d, r as e, o as f, _f as g, y as h };